import * as React from 'react';

var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgMagnifyingGlass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.66 13.78a7.4 7.4 0 111.56 1.56l-.05.06-6.28 6.28a1.1 1.1 0 01-1.57-1.57l6.28-6.28.06-.05zm1.77-.2a5.91 5.91 0 108.36-8.37 5.91 5.91 0 00-8.36 8.36z",
    id: "magnifying-glass_svg__a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    className: "motorway-svg-fill",
    fill: "#1D1D1B",
    href: "#magnifying-glass_svg__a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
}

export { SvgMagnifyingGlass as S };
